import { Bookmark2Icon } from 'components/SvgIcons/Bookmark2Icon';
import { ReportMenuModel } from 'pages/ReportModule/components/ReportMenuItem';
import {
  MENU_REPORT_ACCOUNTS_RECEIVABLE_SALES_JOURNAL_KEY_PERMISSION,
  MENU_REPORT_AGENCY_PERFERMANCE_OVERVIEW_KEY_PERMISSION,
  MENU_REPORT_ARRIVAL_KEY_PERMISSION,
  MENU_REPORT_CASH_REGISTER_KEY_PERMISSION,
  MENU_REPORT_CASHIER_KEY_PERMISSION,
  MENU_REPORT_DAILY_FORECAST_KEY_PERMISSION,
  MENU_REPORT_DAILY_REPORT_KEY_PERMISSION,
  MENU_REPORT_DEPARTURE_KEY_PERMISSION,
  MENU_REPORT_FINANCIAL_ACCOUNT_KEY_PERMISSION,
  MENU_REPORT_FINANCIAL_KEY_PERMISSION,
  MENU_REPORT_FLASH_MANAGER_KEY_PERMISSION,
  MENU_REPORT_FORECAST_BY_ROOM_TYPE_KEY_PERMISSION,
  MENU_REPORT_FOUR_WEEK_FORECAST_KEY_PERMISSION,
  MENU_REPORT_FRONT_DESK_KEY_PERMISSION,
  MENU_REPORT_IN_HOUSE_KEY_PERMISSION,
  MENU_REPORT_NATIONALITY_FORECAST_KEY_PERMISSION,
  MENU_REPORT_PRE_PAYMENT_KEY_PERMISSION,
  MENU_REPORT_RESERVATION_KEY_PERMISSION,
  MENU_REPORT_RESERVATION_LIST_KEY_PERMISSION,
  MENU_REPORT_ROOM_MOVE_KEY_PERMISSION,
  MENU_REPORT_ROOM_STATE_KEY_PERMISSION,
  MENU_REPORT_TRANSACTIONS_LIST_KEY_PERMISSION,
  MENU_REPORT_TRIAL_BALANCE_KEY_PERMISSION,
} from '../ACL/app_report_menu_permission_keys';
import {
  REPORT_AGENCY_PERFERMANCE_OVERVIEW_PATH,
  REPORT_CASHIER_CASH_REGISTER_PATH,
  REPORT_CASHIER_PATH,
  REPORT_CASHIER_PRE_PAYMENT_PATH,
  REPORT_CASHIER_TRANSACTIONS_LIST_PATH,
  REPORT_FINANCIAL_ACCOUNT_REPORT_PATH,
  REPORT_FINANCIAL_ACCOUNT_SRECEIVABLE_SALES_JOURNAL_PATH,
  REPORT_FINANCIAL_PATH,
  REPORT_FLASH_MANAGER_PATH,
  REPORT_FRONTDESK_ARRIVAL_PATH,
  REPORT_FRONTDESK_DAILY_REPORT_PATH,
  REPORT_FRONTDESK_DEPARTURE_PATH,
  REPORT_FRONTDESK_INHOUSE_PATH,
  REPORT_FRONTDESK_PATH,
  REPORT_FRONTDESK_ROOM_MOVE_REPORT_PATH,
  REPORT_FRONTDESK_ROOM_STATE_REPORT_PATH,
  REPORT_RESERVATION_DAILY_FORECAST_PATH,
  REPORT_RESERVATION_FORECAST_BY_ROOM_TYPE_PATH,
  REPORT_RESERVATION_FOUR_WEEK_FORECAST_PATH,
  REPORT_RESERVATION_NATIONALITY_FORECAST_PATH,
  REPORT_RESERVATION_PATH,
  REPORT_RESERVATION_RESERVATION_LIST_PATH,
  REPORT_TRIAL_BALANCE_PATH,
} from './AppPaths/ReportPaths';

export const reportMenuItems: Array<ReportMenuModel> = [
  {
    keyPermission: MENU_REPORT_RESERVATION_KEY_PERMISSION,
    icon: <Bookmark2Icon />,
    name: 'report.menu.reservation',
    path: REPORT_RESERVATION_PATH,
    children: [
      {
        keyPermission: MENU_REPORT_DAILY_FORECAST_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.daily_forecast',
        path: REPORT_RESERVATION_DAILY_FORECAST_PATH,
      },
      {
        keyPermission: MENU_REPORT_FORECAST_BY_ROOM_TYPE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.forecast_by_room_type',
        path: REPORT_RESERVATION_FORECAST_BY_ROOM_TYPE_PATH,
      },
      {
        keyPermission: MENU_REPORT_FOUR_WEEK_FORECAST_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.four_week_forecast',
        path: REPORT_RESERVATION_FOUR_WEEK_FORECAST_PATH,
      },
      {
        keyPermission: MENU_REPORT_RESERVATION_LIST_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.reservation_list',
        path: REPORT_RESERVATION_RESERVATION_LIST_PATH,
      },
      {
        keyPermission: MENU_REPORT_NATIONALITY_FORECAST_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.nationality_forecast',
        path: REPORT_RESERVATION_NATIONALITY_FORECAST_PATH,
      },
    ],
  },
  {
    keyPermission: MENU_REPORT_FRONT_DESK_KEY_PERMISSION,
    icon: <Bookmark2Icon />,
    name: 'report.menu.frontdesk',
    path: REPORT_FRONTDESK_PATH,
    children: [
      {
        keyPermission: MENU_REPORT_ARRIVAL_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.arrival',
        path: REPORT_FRONTDESK_ARRIVAL_PATH,
      },
      {
        keyPermission: MENU_REPORT_DEPARTURE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.departure',
        path: REPORT_FRONTDESK_DEPARTURE_PATH,
      },
      {
        keyPermission: MENU_REPORT_IN_HOUSE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.inhouse',
        path: REPORT_FRONTDESK_INHOUSE_PATH,
      },
      {
        keyPermission: MENU_REPORT_ROOM_STATE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.room_state',
        path: REPORT_FRONTDESK_ROOM_STATE_REPORT_PATH,
      },
      {
        keyPermission: MENU_REPORT_DAILY_REPORT_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.daily_report',
        path: REPORT_FRONTDESK_DAILY_REPORT_PATH,
      },
      // {
      //   keyPermission: MENU_REPORT_LOGS_KEY_PERMISSION,
      //   icon: <Bookmark2Icon />,
      //   name: 'report.menu.logs',
      //   path: REPORT_FRONTDESK_LOGS_REPORT_PATH,
      // },
      {
        keyPermission: MENU_REPORT_ROOM_MOVE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.room_move',
        path: REPORT_FRONTDESK_ROOM_MOVE_REPORT_PATH,
      },
    ],
  },
  {
    keyPermission: MENU_REPORT_CASHIER_KEY_PERMISSION,
    icon: <Bookmark2Icon />,
    name: 'report.menu.cashier',
    path: REPORT_CASHIER_PATH,
    children: [
      {
        keyPermission: MENU_REPORT_CASH_REGISTER_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.cash_register',
        path: REPORT_CASHIER_CASH_REGISTER_PATH,
      },
      {
        keyPermission: MENU_REPORT_TRANSACTIONS_LIST_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.transactions_list',
        path: REPORT_CASHIER_TRANSACTIONS_LIST_PATH,
      },
      {
        keyPermission: MENU_REPORT_PRE_PAYMENT_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.pre_payment',
        path: REPORT_CASHIER_PRE_PAYMENT_PATH,
      },
    ],
  },
  // {
  //   keyPermission: MENU_REPORT_HOUSE_KEEPING_KEY_PERMISSION,
  //   icon: <Bookmark2Icon />,
  //   name: 'report.menu.housekeeping',
  //   path: REPORT_HOUSEKEEPING_PATH,
  //   children: [
  //     {
  //       keyPermission: MENU_REPORT_HOUSE_KEEPING_KEY_PERMISSION,
  //       icon: <Bookmark2Icon />,
  //       name: 'report.menu.comming_soon',
  //       path: '',
  //     },
  //   ],
  // },
  {
    keyPermission: MENU_REPORT_FINANCIAL_KEY_PERMISSION,
    icon: <Bookmark2Icon />,
    name: 'report.menu.financial',
    path: REPORT_FINANCIAL_PATH,
    children: [
      {
        keyPermission: MENU_REPORT_ACCOUNTS_RECEIVABLE_SALES_JOURNAL_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.accounts_receivable_sales_journal',
        path: REPORT_FINANCIAL_ACCOUNT_SRECEIVABLE_SALES_JOURNAL_PATH,
      },
      {
        keyPermission: MENU_REPORT_FLASH_MANAGER_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.flash_manager',
        path: REPORT_FLASH_MANAGER_PATH,
      },
      {
        keyPermission: MENU_REPORT_TRIAL_BALANCE_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.trial_balance',
        path: REPORT_TRIAL_BALANCE_PATH,
      },
      {
        keyPermission: MENU_REPORT_AGENCY_PERFERMANCE_OVERVIEW_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.agency_perfermance_overview',
        path: REPORT_AGENCY_PERFERMANCE_OVERVIEW_PATH,
      },
      {
        keyPermission: MENU_REPORT_FINANCIAL_ACCOUNT_KEY_PERMISSION,
        icon: <Bookmark2Icon />,
        name: 'report.menu.financial_account',
        path: REPORT_FINANCIAL_ACCOUNT_REPORT_PATH,
      },
    ],
  },
  // {
  //   keyPermission: MENU_REPORT_NIGHT_AUDIT_KEY_PERMISSION,
  //   icon: <Bookmark2Icon />,
  //   name: 'report.menu.night_audit',
  //   path: REPORT_NIGHT_AUDIT_PATH,
  //   children: [
  //     {
  //       keyPermission: MENU_REPORT_NIGHT_AUDIT_KEY_PERMISSION,
  //       icon: <Bookmark2Icon />,
  //       name: 'report.menu.comming_soon',
  //       path: '',
  //     },
  //   ],
  // },
];
